import React from 'react';
import { useTranslation } from 'react-i18next';

const TablePagination = ({
  currentPage = 1,
  totalPages = 1,
  onPrev,
  onNext,
  disablePrev = false,
  disableNext = false,
}) => {
  const { t } = useTranslation();

  const safeCurrent = Math.max(1, currentPage || 1);
  const safeTotal = Math.max(1, totalPages || 1);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 12,
        padding: '0 16px',
      }}
    >
      <button
        type="button"
        onClick={() => {
          if (!disablePrev && typeof onPrev === 'function') onPrev();
        }}
        disabled={disablePrev}
        style={{
          padding: '6px 12px',
          borderRadius: '8px',
          border: '1px solid #E5E7EB',
          backgroundColor: disablePrev ? '#F9FAFB' : '#F3F4F6',
          color: disablePrev ? '#9CA3AF' : '#111827',
          cursor: disablePrev ? 'default' : 'pointer',
          fontSize: 13,
          minWidth: 100,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 6,
        }}
      >
        <img
          src="/Images/left-arrow.png"
          alt={t('Précédent')}
          style={{ width: 6, height: 6, opacity: disablePrev ? 0.4 : 1 }}
        />
        <span>{t('Précédent')}</span>
      </button>

      <span style={{ fontSize: 13, color: '#6B7280' }}>
        {t('Page {{current}} sur {{total}}', {
          current: safeCurrent,
          total: safeTotal,
        })}
      </span>

      <button
        type="button"
        onClick={() => {
          if (!disableNext && typeof onNext === 'function') onNext();
        }}
        disabled={disableNext}
        style={{
          padding: '6px 12px',
          borderRadius: '8px',
          border: '1px solid #E5E7EB',
          backgroundColor: disableNext ? '#F9FAFB' : '#F3F4F6',
          color: disableNext ? '#9CA3AF' : '#111827',
          cursor: disableNext ? 'default' : 'pointer',
          fontSize: 13,
          minWidth: 100,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 6,
        }}
      >
        <span>{t('Suivant')}</span>
        <img
          src="/Images/right-arrow.png"
          alt={t('Suivant')}
          style={{
            width: 6,
            height: 6,
            opacity: disableNext ? 0.4 : 1,
          }}
        />
      </button>
    </div>
  );
};

export default TablePagination;


